// extracted by mini-css-extract-plugin
module.exports = {"root":"_3aRVN","bg":"_8V8P8","b":"_1CD4U"};